import script from "./AdminEmployee.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminEmployee.vue?vue&type=script&setup=true&lang=js"

import "./AdminEmployee.vue?vue&type=style&index=0&id=8c15e47c&lang=css"

const __exports__ = script;

export default __exports__